import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['checkbox', 'bulkButtons']
  static values = { checkboxesChecked: Number }

  connect() {
    useDispatch(this)
    this.checkboxesCheckedValueChanged()
  }

  updateCheckboxesCheckedValue(event) {
    if (event.detail) {
      const key = Object.keys(event.detail)[0]
      this.checkboxesCheckedValue = event.detail[key]
    }
  }

  checkboxesCheckedValueChanged() {
    this.toggleBulkButtonsDisabledAttribute(this.checkboxesCheckedValue <= 0)
  }

  get checkboxesChecked() {
    return this.checkboxTargets.filter((checkbox) => { return checkbox.checked })
  }

  triggerBulkDelete() {
    if (!event.currentTarget.hasAttribute('disabled')) {
      const ids = []
      this.checkboxesChecked.forEach(checkbox => ids.push(checkbox.dataset.referenceId))
      this.dispatch('triggerBulkDelete', { exportsIdsToDelete: ids })
      Rails.ajax({
        type: 'delete',
        url: '/exports/bulk_delete',
        data: `ids=${ids}`,
        success: (data) => {
          this.dispatch('triggerBulkDelete-success')
        },
        error: () => alert('Something went wrong')
      })
    }
  }

  triggerBulkDownload(event) {
    if (!event.currentTarget.hasAttribute('disabled')) {
      const ids = []
      this.checkboxesChecked.forEach(checkbox => ids.push(checkbox.dataset.referenceId))
      this.dispatch('triggerbBulkDownload', { downloadedExportsIds: ids })

      ids.forEach(id => { window.open($(`#download-export-${id}`)[0].href, '_blank') })
    }
  }

  triggerBulkMigrate(event) {
    if (!event.currentTarget.hasAttribute('disabled')) {
      const ids = []
      this.checkboxesChecked.forEach(checkbox => ids.push(checkbox.dataset.referenceId))
      Rails.ajax({
        type: 'get',
        url: '/exports/bulk_migrate_v2',
        data: `ids=${ids}`,
        error: () => alert('Something went wrong')
      })
    }
  }

  toggleBulkButtonsDisabledAttribute(showAttribute) {
    if (showAttribute) {
      this.bulkButtonsTargets.forEach((button) => {
        button.setAttribute('disabled', 'true')
      })
    } else {
      this.bulkButtonsTargets.forEach((button) => {
        button.removeAttribute('disabled')
      })
    }
  }
}
